<template>
  <div>
    <div v-if="title" class="lyon-display-medium-24 mb-3">{{ title }}</div>
    <div v-for="item in filteredFormData" :key="item.label" class="row mb-3">
      <div class="col-md-4">
        <span class="text-muted regular-16">
          <span v-if="item.onlyMsri">
            <span v-if="canAccessPublicAndAdmin()">
              {{ item.label }}
            </span>
          </span>
          <span v-else>{{ item.label }}</span>
        </span>
      </div>
      <div class="col-md-8">
        <div v-if="item.isArrayData" class="regular-16">
          <span v-if="item.value.length > 0">
            <span v-for="(data, index) in item.value" :key="index" class="regular-16">
              {{ data.name }}<span v-if="index < item.value.length - 1">,</span>
            </span>
          </span>
          <span v-else class="regular-16"> -- </span>
        </div>
        <div v-else class="regular-16">
          <span v-if="item.onlyMsri">
            <span v-if="canAccessPublicAndAdmin()">
              <span v-if="checkNullAndEmptyValues(item.value)">
                <span v-if="item.href">
                  <a :href="item.href" target="_blank">{{ item.value }}</a>
                </span>
                <span v-else>{{ item.value }}</span>
              </span>
              <span v-else>
                --
              </span>
            </span>
          </span>
          <span v-else>
            <span v-if="checkNullAndEmptyValues(item.value)">
              <span v-if="item.href">
                <a :href="item.href" target="_blank">{{ item.value }}</a>
              </span>
              <span v-else-if="item.isHtml" v-html="item.value" />
              <span v-else>{{ item.value }}</span>
            </span>
            <span v-else>
              --
            </span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js'

export default {
  name: "PersonInformation",
  mixins: [mixin],
  props: ['title', 'formData'],
  computed: {
    filteredFormData() {
      return this.formData.filter(item => item.onlyMsri || item.onlyMsri === undefined);
    }
  }
}
</script>

